import React, { PureComponent } from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export class FillButton extends PureComponent<IProps> {
    render() {
        const {
            Button,
            Link,
            advCodes = [],
            buttonSize,
            buttonText = 'Заполнить заявку',
            buttonWidth = 'full',
            id = '',
            isMobile,
            kind = 'red',
            onClick,
            openPageInNewWindow,
            styles = {},
            theme = 'white',
            url,
            classNames = {},
        } = this.props;

        const computedButtonSize = buttonSize || (isMobile ? 'm' : 'l');

        return (
            // ToDo: Артемьев Федор, поправить добавление стилей (попробовать &)
            <div
                className={cn(styles.buttonContainer, classNames.container, {
                    [classNames.containerMargin]: classNames.containerMargin,
                    [styles.containerMargin]: !classNames.containerMargin,
                })}
            >
                <Link
                    advCodes={advCodes}
                    border="hidden"
                    href={url}
                    target={openPageInNewWindow ? '_blank' : undefined}
                >
                    <Button
                        id={id}
                        kind={kind}
                        onClick={onClick}
                        size={computedButtonSize}
                        theme={theme}
                        width={buttonWidth}
                    >
                        {buttonText}
                    </Button>
                </Link>
            </div>
        );
    }
}
